import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCdnImageUrl } from '../utils/cdn';
import './SearchBar.css';

const SearchBar = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!query.trim() || query.trim().length < 2) {
      setResults([]);
      return;
    }

    const timer = setTimeout(async () => {
      setIsLoading(true);
      try {
        const res = await fetch(`/api/search?q=${encodeURIComponent(query)}`);
        if (res.ok) {
          const data = await res.json();
          setResults(data.results || []);
        }
      } catch (err) {
        console.error('Search error:', err);
      } finally {
        setIsLoading(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [query]);

  if (!isOpen) return null;

  const handleSelect = (item) => {
    onClose();
    if (item.type === 'detail') {
      navigate(`/content-display-one/${encodeURIComponent(item.region)}/${encodeURIComponent(item.title)}`);
    } else {
      navigate('/region', { state: { region: item.region } });
    }
  };

  return (
    <div className="search-overlay" onClick={onClose}>
      <div className="search-modal" onClick={(e) => e.stopPropagation()}>
        <div className="search-header">
          <input
            ref={inputRef}
            type="text"
            placeholder="Search destinations, itineraries, regions..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="search-input"
          />
          <button className="search-close-btn" onClick={onClose}>&times;</button>
        </div>

        {isLoading && <div className="search-loading">Searching destinations...</div>}

        <div className="search-results">
          {!isLoading && query.trim().length >= 2 && results.length === 0 && (
            <div className="search-empty">No destinations found matching "{query}"</div>
          )}

          {results.map((item, idx) => (
            <div key={idx} className="search-item" onClick={() => handleSelect(item)}>
              {item.image && (
                <img
                  src={getCdnImageUrl(item.image)}
                  alt={item.title}
                  className="search-item-img"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              )}
              <div className="search-item-info">
                <h4>{item.title}</h4>
                <span className="search-item-tag">{item.region}</span>
                {item.description && <p>{item.description.replace(/<[^>]*>?/gm, '').substring(0, 90)}...</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
